module.exports = __webpack_public_path__ + "img/Mixed-fruits-200x132.fbe3e6ca.jpg";